// This file is automatically generated. Do not edit manually.

import { ProductChangeRequest } from "src/api/generated/erp/db/types/tables/productChangeRequest";
import { ProductChangeRequestState } from "src/api/generated/erp/db/types/enums/productChangeRequestState";
import { ProductChangeCategory } from "src/api/generated/erp/db/types/tables/productChangeCategory";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace ProductChangeRequestEditApi {
	export async function getInitData(args: {
		productChangeRequestId: number | null | undefined;
	}): Promise<ProductChangeRequestEditApi_FormInitData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productChanges/requests/edit/getInitData",
			method: "POST",
			data: {
				productChangeRequestId: args.productChangeRequestId,
			},
		});
		return response as ProductChangeRequestEditApi_FormInitData;
	}

	export async function updateAsManager(args: {
		productChangeRequest: ProductChangeRequest;
	}): Promise<ProductChangeRequest> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productChanges/requests/edit/updateAsManager",
			method: "POST",
			data: {
				productChangeRequest: args.productChangeRequest,
			},
		});
		return response as ProductChangeRequest;
	}

	export async function updateMyRequest(args: {
		productChangeRequestId: number;
		title: string;
		description: string;
		categoryId: number;
	}): Promise<ProductChangeRequest> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productChanges/requests/edit/updateMyRequest",
			method: "POST",
			data: {
				productChangeRequestId: args.productChangeRequestId,
				title: args.title,
				description: args.description,
				categoryId: args.categoryId,
			},
		});
		return response as ProductChangeRequest;
	}

	export async function setState(args: {
		productChangeRequestIds: Array<number>;
		state: ProductChangeRequestState;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productChanges/requests/edit/setState",
			method: "POST",
			data: {
				productChangeRequestIds: args.productChangeRequestIds,
				state: args.state,
			},
		});
		return response as void;
	}
}

export interface ProductChangeRequestEditApi_FormInitData {
	categoryOptions: Array<ProductChangeCategory>;
	productChangeRequest: ProductChangeRequest | null | undefined;
}
